import { Injectable } from '@angular/core';
import { IndexedDbService } from '../../../shared/services/indexedDb.service';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { map } from 'rxjs/operators';
import { DataService } from '../../../shared/services';
import { of } from 'rxjs';

@Injectable()
export class InstallationObservationFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateObservationsAndRecommendations(inspectionId: string, pointId: string, pluginId: string, data: any) {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            this._updateObservationsAndRecommendations(plugin, data);
            return plugin;
          }
        })
      );
    }
    return this.getInspection(inspectionId).pipe(
      map((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin) {
          this._updateObservationsAndRecommendations(plugin, data);
          plugin.etag = new Date();
          this.updateInspection(inspection);
          return plugin;
        }
        return null;
      })
    );
  }

  public updateObservationPlugins(inspectionId: string, pluginId: string, observationId: string, plugins: any[]) {
    if (this.isManager) {
      return of(null);
    }
    return this.getInspection(inspectionId).pipe(
      map((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin && plugin.config.ObservationsAndRecommendations) {
          const observation = plugin.config.ObservationsAndRecommendations.find((o) => o.Id === observationId);
          if (observation) {
            observation.Plugins = plugins;
          }
          this.updateInspection(inspection);
          return { plugin };
        }
        return null;
      })
    );
  }

  private _updateObservationsAndRecommendations(plugin, data) {
    if (data.ObservationsAndRecommendations) {
      data.ObservationsAndRecommendations.forEach((obs) => {
        if (!obs.Id) {
          obs.Id = this.guid();
        }
        if (obs.Machines && obs.Machines.length > 0) {
          obs.Machines = obs.Machines.map((m) => {
            return {
              ModelId: m.ModelId,
              ProductLine: m.ProductLine,
              SerialNumber: m.SerialNumber ? m.SerialNumber : '',
              Supplier: m.Supplier
            };
          });
        }
      });
    }
    plugin.config.ObservationsAndRecommendations = data.ObservationsAndRecommendations;
    plugin.config.MessageInfo = data.MessageInfo;
  }
}
